// src/setup/fetch403Patch.js

const { API_FORBIDDEN_ERROR } = require("@/lib/errors/error-constants");

// (function patchFetch403() {
//   if (
//     typeof window === "undefined" ||
//     !window.fetch ||
//     window.fetch.__patched403
//   )
//     return;

//   const originalFetch = window.fetch.bind(window);

//   window.fetch = async (...args) => {
//     const res = await originalFetch(...args);

//     if (res && res.status === 403) {
//       const err = new Error(API_FORBIDDEN_ERROR);
//       err.response = { status: 403 };
//       throw err;
//     }

//     return res;
//   };

//   window.fetch.__patched403 = true;
// })();


if (typeof window !== "undefined" && window.fetch) {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    if (res.status === 403) {
      const err = new Error(API_FORBIDDEN_ERROR);
      err.response = { status: 403 };
      throw err;
    }

    return res;
  };
}